/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS } from 'immutable';

const clear = (state) => state.clear();

const remove = (state, action) => state.delete(action.data);

const occured = (state, action) => {
  if (action.data.status === 0) {
    return state
      .clear()
      .set('exception', false)
      .set('Server dropped connection',
        'possible reasons - connection problems or attachment`s size is too large (>100mb))');
  } else if (action.data.status === 400 && action.data.exception !== false) {
    return state
      .clear()
      .set('exception', false)
      .set('Bad request', 'possible reasons - one of fields may have incorrect data');
  }
  let newState = state
    .clear()
    .set('popupHidden', !!action.data.popupHidden);
  if (action.data.message) {
    newState = newState.set('message', action.data.message)
      .set('exception', false).set('alert', true);
  } else {
    newState = newState.merge(fromJS(action.data))
      .map(msg => (msg && typeof msg === 'string' && msg.length > 0
        ? msg.charAt(0).toUpperCase() + msg.slice(1)
        : msg));
  }

  if (action.data.exception === false) {
    return newState.delete('status');
  }

  return newState;
};

const hideErrorPopup = (state) => state.set('popupHidden', true);

export const errorReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'ERROR_OCCURRED':
      return occured(state, action);
    case 'REMOVE_ERROR':
      return remove(state, action);
    case '@@router/LOCATION_CHANGE': // dunno if it's enough... but we'll leave it like this for now
    case 'CLEAR_ERRORS':
      return clear(state);
    case 'HIDE_ERROR_POPUP':
      return hideErrorPopup(state);
    default:
      return state;
  }
};

export const putError = (dispatch, error) => dispatch({ type: 'ERROR_OCCURRED', data: error });
export const removeError = (dispatch, key) => dispatch({ type: 'REMOVE_ERROR', data: key });
export const clearErrors = (dispatch) => dispatch({ type: 'CLEAR_ERRORS' });
export const hidePopup = (dispatch) => dispatch({ type: 'HIDE_ERROR_POPUP' });
